import { Hairline, Label } from "@components";
import style from "@styles/pages/oraculo/oraculo.module.scss";

import { CustomerTag, WeekPeriod } from "@core/oraculo/CustomerTag";
import { Tag } from "./Tag";

export default ({ customers, tags = {}, filters, onSelectFilters }) => {
  const mountedTags = CustomerTag.fromStats(WeekPeriod, tags, customers);

  return (
    <>
      <Hairline solid className="mt-20 mb-20" />

      <Label>Quando pedem</Label>
      <div className={style.fourGrid}>
        {mountedTags.map((tag) => (
          <Tag
            key={tag.id}
            id={String(tag.id)}
            name={tag.name}
            icon={tag.icon}
            quantity={tag.quantity}
            percentage={tag.getFormattedPercentage()}
            filters={filters}
            onSelectFilters={onSelectFilters}
          />
        ))}
      </div>
    </>
  );
};
